import React from 'react';

// Hairline pills. Colour appears only as text, and only for better / off-track.
const Badge = React.forwardRef(({ className, variant = "default", ...props }, ref) => {
  const variants = {
    default: "border border-line text-fg-3",
    primary: "border border-line-strong text-fg",
    secondary: "border border-line text-fg-3",
    destructive: "border border-line text-off-strong dark:text-off",
    outline: "border border-line-strong text-fg-2",
    success: "border border-line text-good-strong dark:text-good",
    warning: "border border-line-strong text-fg-2",
  };

  return (
    <div
      ref={ref}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium bg-transparent ${variants[variant]} ${className || ''}`}
      {...props}
    />
  );
});

Badge.displayName = "Badge";

export { Badge };
